import MerchantWhitelistTable from './MerchantWhitelistTable';

export default MerchantWhitelistTable;